module.exports = __webpack_public_path__ + "./assets/6d522484d4f4d401fc0b4b96ada56cd9.svg";